<style lang="scss" scoped>
.app {
	&__text {
		width: 426px;
	}
	&__logo {
		width: 80px;
		height: 100%;
		border-radius: 5px;
		display: block;
		float: left;
		margin-right: 20px;
		@include sm-and-down {
			width: 60px;
		}
	}
	&__inner {
		padding: 30px;
		cursor: pointer;
		@include sm-and-down {
			padding: 15px;
		}
	}
	&__description {
		margin-top: 10px;
		word-break: break-word !important;
		@include sm-and-down {
			display: none !important;
		}
	}
	&__flex {
		@include flex-center;
	}
	&__title {
		font-size: 20px;
		line-height: 20px;
		@include sm-and-down {
			font-size: 16px;
			line-height: 16px;
		}
	}
}
</style>

<template lang="pug">
    .app
        panel(:padding="false")
            router-link(tag="div", :to="{ name: 'application', params: {slug: company.slug} }").app__inner
                .app__flex
                    img(v-if="company.application_logo", ref="img", :src="company.application_logo").app__logo
                    .app__text
                        h3.app__title {{ company.name }}
                        p.app__description(v-line-clamp="2") {{ company.application_short_description }}
</template>

<script>
export default {
	props: {
		company: {
			type: Object,
			required: true
		}
	},
	mounted() {
		// This is to resolve a weird bug in Safari where the logos do not display until a redraw triggers the image
		// So here we're going to target Safari users, and once the image has loaded we then hide and then instantly display the image to trigger a redraw
		var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

		if (!isSafari || !this.company.application_logo) return;

		this.$refs.img.addEventListener("load", () => {
			this.$refs.img.style.display = "none";

			setTimeout(() => {
				this.$refs.img.style.display = "block";
			}, 0);
		});
	}
};
</script>
